import { ManagementType } from "types/common";
import { USER_GROUPS } from "constants/roles";
import Pagination from "../../../../../components/Pagination/Pagination";

type PaginationByRoleProps = {
  managementType?: ManagementType;
  currentClinician: any;
  clinicPatientsPage: number;
  clinicPatientsTotalPages: number;
  onClinicPatientsPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  clinicPatientsLoading: any;
  clinicianPatientsPage: number;
  clinicianPatientsTotalPages: number;
  onClinicianPatientsPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  clinicianPatientsLoading: any;
  usersPage: number;
  usersTotalPages: number;
  onUsersPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  usersLoading: any;
};

const PaginationByRole = ({
  currentClinician,
  managementType,
  clinicPatientsPage,
  clinicPatientsTotalPages,
  onClinicPatientsPageChange,
  clinicPatientsLoading,
  clinicianPatientsPage,
  clinicianPatientsTotalPages,
  onClinicianPatientsPageChange,
  clinicianPatientsLoading,
  usersPage,
  usersTotalPages,
  onUsersPageChange,
  usersLoading,
}: PaginationByRoleProps) => {
  return (
    <>
      {(currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD)) &&
        managementType == ManagementType.PATIENT && (
          <Pagination
            page={clinicPatientsPage}
            count={clinicPatientsTotalPages}
            onChange={onClinicPatientsPageChange}
            disabled={clinicPatientsLoading}
          />
        )}
      {currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_MEMBER) &&
        managementType == ManagementType.PATIENT_CARE && (
          <Pagination
            page={clinicianPatientsPage}
            count={clinicianPatientsTotalPages}
            onChange={onClinicianPatientsPageChange}
            disabled={clinicianPatientsLoading}
          />
        )}
      {managementType == ManagementType.USER && (
        <Pagination
          page={usersPage}
          count={usersTotalPages}
          onChange={onUsersPageChange}
          disabled={usersLoading}
        />
      )}
    </>
  );
};

export default PaginationByRole;
